// import { userBookingFun } from "../../../api/userAPI";
import { userReviewCount, userReviewFun } from '../../../api/userAPI';
import errorHandle from '../../../utils/errorHandle';

export default async function myReviewData(typeSel, setReviewData, setLoading) {
    //API call for fetching booking data of a particular user
    setLoading(true);
    try {
        const review = await userReviewFun(typeSel);
        setReviewData(review.data);
        setLoading(false);
    } catch (error) {
        errorHandle(error);
        setLoading(false);
    }
}

export async function myReviewCount(typeSel, setTotalData) {
    const reviewCount = await userReviewCount(typeSel);
    setTotalData(reviewCount.data.count);
}
